
















import { Component, Vue, Prop, Provide } from 'vue-property-decorator'

@Component
export default class UploadPhotos extends Vue {
  private get user() {
    return this.$store.state.user
  }
  public goPhotoSearch() {
    if (this.user && this.user.name) {
      location.href = '/question/photosearch'
    } else {
      this.$store.commit('SET_LOGINMODAL', true)
    }
  }
}
